// Debug utility to check token and API connectivity
export const checkToken = () => {
  const token = localStorage.getItem('token');
  if (!token) {
    console.error('❌ No token found in localStorage');
    return false;
  }
  
  console.log('✅ Token found:', token.substring(0, 50) + '...');
  
  // Decode JWT to check expiration
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    console.log('Token payload:', payload);
    
    if (payload.exp) {
      const expirationDate = new Date(payload.exp * 1000);
      const now = new Date();
      if (expirationDate < now) {
        console.error('❌ Token has expired:', expirationDate);
        return false;
      } else {
        console.log('✅ Token expires at:', expirationDate);
      }
    }
  } catch (e) {
    console.warn('Could not decode token:', e);
  }
  
  return true;
};

export const testAPI = async () => {
  const token = localStorage.getItem('token');
  if (!token) {
    console.error('No token available for API test');
    return;
  }
  
  try {
    const response = await fetch('https://sayagainservices.sayagain.ai/api/admin/users?page=1&page_size=1', {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    });
    
    console.log('API Response Status:', response.status);
    console.log('API Response Headers:', Object.fromEntries(response.headers.entries()));
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('API Error Response:', errorText);
    } else {
      const data = await response.json();
      console.log('API Success Response:', data);
    }
  } catch (error) {
    console.error('API Test Error:', error);
  }
};

